export default __webpack_public_path__ + "static/logo-77dbffd6f25ba631f63ac4267525be44.svg";